import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { getPayCategoryCardWidgetStyles } from './PayCategoryCardWidgetStyles';
import { Callout, Card, Checkbox, getTestId, Input, isValidObject } from '@airtel/air-design-system';
import { CalloutWidget } from '../callout-widget';
import { InputWidget } from '../input-widget';
import { ButtonWidget } from '../button-widget';
import { OfferContextualStripWidget } from '../offer-contextual-strip-widget';
import { View } from 'react-native';
import { dateHandler } from './PayCategoryCardWidgetUtils';
export var PayCategoryCardWidgetComponent = props => {
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'PayCategoryCardWidget' : _props$testID,
    primaryCallout = props.primaryCallout,
    topSelectionCalloutProps = props.topSelectionCalloutProps,
    secondaryCallout = props.secondaryCallout,
    tertiaryCallout = props.tertiaryCallout,
    cardNumberInputProps = props.cardNumberInputProps,
    cardNameInputProps = props.cardNameInputProps,
    cardDateInputProps = props.cardDateInputProps,
    cardCVVInputProps = props.cardCVVInputProps,
    buttonProps = props.buttonProps,
    validateCardMetaData = props.validateCardMetaData,
    style = props.style,
    _props$showTrustMarke = props.showTrustMarker,
    showTrustMarker = _props$showTrustMarke === void 0 ? true : _props$showTrustMarke,
    trustMarkerCtaOnPressMetaData = props.trustMarkerCtaOnPressMetaData,
    onCheckBoxPressMetaData = props.onCheckBoxPressMetaData,
    trustMarkerCtaTitle = props.trustMarkerCtaTitle,
    trustMarkerTitle = props.trustMarkerTitle,
    _props$isChecked = props.isChecked,
    isChecked = _props$isChecked === void 0 ? true : _props$isChecked,
    _props$minCardNumberL = props.minCardNumberLength,
    minCardNumberLength = _props$minCardNumberL === void 0 ? 0 : _props$minCardNumberL,
    _props$enableScroll = props.enableScroll,
    enableScroll = _props$enableScroll === void 0 ? false : _props$enableScroll,
    scrollMetaData = props.scrollMetaData,
    _props$isCurrentItemV = props.isCurrentItemVisible,
    isCurrentItemVisible = _props$isCurrentItemV === void 0 ? true : _props$isCurrentItemV,
    onInvisibleItemMountMetaData = props.onInvisibleItemMountMetaData,
    offerStripProps = props.offerStripProps,
    _props$calloutProps = props.calloutProps,
    calloutProps = _props$calloutProps === void 0 ? [] : _props$calloutProps,
    _props$resetInputData = props.resetInputData,
    resetInputData = _props$resetInputData === void 0 ? false : _props$resetInputData,
    _onUserAction = props.onUserAction;
  var payCategoryCardWidgetStyles = getPayCategoryCardWidgetStyles(props);
  var maginVertical8 = payCategoryCardWidgetStyles.maginVertical8;
  var _useState = useState(''),
    cardNumber = _useState[0],
    setCardNumber = _useState[1];
  var _useState2 = useState(''),
    date = _useState2[0],
    setDate = _useState2[1];
  var _useState3 = useState(''),
    cvv = _useState3[0],
    setCvv = _useState3[1];
  var _useState4 = useState(''),
    dateHint = _useState4[0],
    setDateHint = _useState4[1];
  var _useState5 = useState(cardCVVInputProps === null || cardCVVInputProps === void 0 ? void 0 : cardCVVInputProps.appendItems),
    appendItems = _useState5[0],
    setAppendItems = _useState5[1];
  var _useState6 = useState(true),
    isSecureTextEntry = _useState6[0],
    setIsSecureTextEntry = _useState6[1];
  var _useState7 = useState('disabled'),
    controlState = _useState7[0],
    setControlState = _useState7[1];
  var _useState8 = useState(isChecked),
    checked = _useState8[0],
    setChecked = _useState8[1];
  var viewRef = useRef(null);
  var handleScrolling = () => {
    setTimeout(() => {
      viewRef.current.measure((_, __, ___, ____, _____, pageY) => {
        scrollMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
          id
        }, scrollMetaData), Object.assign(Object.assign({}, props), {
          position: pageY
        })));
      });
    }, 500);
  };
  useEffect(() => {
    if (enableScroll) {
      if (!isCurrentItemVisible) {
        onInvisibleItemMountMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({}, onInvisibleItemMountMetaData), Object.assign({}, props)));
      } else {
        handleScrolling();
      }
    }
  }, [enableScroll]);
  useEffect(() => {
    if (resetInputData) {
      setCardNumber('');
      setDate('');
      setCvv('');
    }
  }, [resetInputData]);
  useEffect(() => {
    if (isCurrentItemVisible && enableScroll && viewRef.current) {
      handleScrolling();
    }
  }, [isCurrentItemVisible]);
  var onAppendItemPress = () => {
    if (isSecureTextEntry) {
      setAppendItems(prevStateObj => Object.assign(Object.assign({}, prevStateObj), {
        prefixIcon: Object.assign(Object.assign({}, prevStateObj.prefixIcon), {
          iconName: 'HideButtonIcon'
        })
      }));
    } else {
      setAppendItems(prevStateObj => Object.assign(Object.assign({}, prevStateObj), {
        prefixIcon: Object.assign(Object.assign({}, prevStateObj.prefixIcon), {
          iconName: 'ShowButtonIcon'
        })
      }));
    }
    setIsSecureTextEntry(!isSecureTextEntry);
  };
  var onDateHandler = text => {
    var _dateHandler = dateHandler(text),
      editable = _dateHandler.editable,
      dateHint = _dateHandler.dateHint;
    setDate(editable);
    setDateHint(dateHint);
  };
  var onInputChangeHandler = data => {
    var digitsOnly = data.replace(/\D/g, '');
    var formattedText = '';
    validateCardMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({}, validateCardMetaData), {
      cardNumber: digitsOnly,
      previousCardNumber: cardNumber.replace(/\D/g, ''),
      props
    }));
    for (var i = 0; i < digitsOnly.length; i++) {
      if (i > 0 && i % 4 === 0) {
        formattedText += ' ';
      }
      formattedText += digitsOnly[i];
    }
    setCardNumber(formattedText);
  };
  var getInputState = () => {
    return dateHint === '' || dateHint === undefined ? 'none' : 'error';
  };
  var setButtonState = () => {
    if (cardNumber.length >= minCardNumberLength && cardNumber.length <= (cardNumberInputProps === null || cardNumberInputProps === void 0 ? void 0 : cardNumberInputProps.maxLength) && cvv.length === (cardCVVInputProps === null || cardCVVInputProps === void 0 ? void 0 : cardCVVInputProps.maxLength) && dateHint === '' && date.length === 5) {
      setControlState('none');
    } else {
      setControlState('disabled');
    }
  };
  var trustMarkerCtaonPress = () => {
    trustMarkerCtaOnPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({}, trustMarkerCtaOnPressMetaData), {
      props
    }));
  };
  var hintActionOnPressFunc = () => {
    (cardCVVInputProps === null || cardCVVInputProps === void 0 ? void 0 : cardCVVInputProps.onHintActionPressMetaData) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({}, cardCVVInputProps.onHintActionPressMetaData), props));
  };
  useEffect(() => {
    setButtonState();
  }, [cardNumber, cvv, dateHint, date]);
  var inputFieldOnPress = inputProps => {
    (inputProps === null || inputProps === void 0 ? void 0 : inputProps.onFocusMetaData) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({}, inputProps.onFocusMetaData), props));
  };
  var onCalloutCtaPress = onCtaPress => {
    isValidObject(onCtaPress) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, onCtaPress), props));
  };
  return _jsxs(Card, Object.assign({
    ref: viewRef
  }, getTestId(testID), {
    style: [style]
  }, {
    children: [isValidObject(topSelectionCalloutProps) && _jsx(CalloutWidget, Object.assign({}, topSelectionCalloutProps, getTestId(testID, 'Callout'), {
      style: [maginVertical8],
      onUserAction: _onUserAction
    })), isValidObject(primaryCallout) && _jsx(CalloutWidget, Object.assign({}, primaryCallout, getTestId(testID, 'Callout'), {
      style: [maginVertical8],
      onUserAction: _onUserAction
    })), isValidObject(cardNumberInputProps) && _jsx(Input, Object.assign({
      value: cardNumber
    }, cardNumberInputProps, getTestId(testID, 'Input'), {
      maxLength: cardNumberInputProps === null || cardNumberInputProps === void 0 ? void 0 : cardNumberInputProps.maxLength,
      containerStyle: maginVertical8,
      showClearButton: false,
      onClearButtonPress: () => {
        setCardNumber('');
        onInputChangeHandler('');
      },
      onChangeText: onInputChangeHandler,
      onFocus: () => {
        inputFieldOnPress(cardNumberInputProps);
      }
    })), isValidObject(secondaryCallout) && _jsx(CalloutWidget, Object.assign({}, secondaryCallout, getTestId(testID, 'Callout'), {
      style: [maginVertical8],
      onUserAction: _onUserAction
    })), isValidObject(cardNameInputProps) && _jsx(InputWidget, Object.assign({}, cardNameInputProps, getTestId(testID, 'Input'), {
      style: [maginVertical8],
      onUserAction: _onUserAction
    })), isValidObject(offerStripProps) && _jsx(OfferContextualStripWidget, Object.assign({}, offerStripProps, {
      style: maginVertical8
    }, getTestId(testID, 'offerStrip'), {
      onUserAction: _onUserAction
    })), isValidObject(tertiaryCallout) && _jsx(CalloutWidget, Object.assign({}, tertiaryCallout, getTestId(testID, 'TertiaryCallout'), {
      style: [maginVertical8],
      onUserAction: _onUserAction
    })), (calloutProps === null || calloutProps === void 0 ? void 0 : calloutProps.length) > 0 && calloutProps.map(calloutProp => {
      return _jsx(_Fragment, {
        children: Object.keys(calloutProp).length > 0 && _jsx(Callout, Object.assign({
          style: maginVertical8
        }, calloutProp, {
          onCtaPress: () => onCalloutCtaPress(calloutProp === null || calloutProp === void 0 ? void 0 : calloutProp.onCtaPress)
        }))
      });
    }), (isValidObject(cardDateInputProps) || isValidObject(cardCVVInputProps)) && _jsxs(View, Object.assign({
      style: [payCategoryCardWidgetStyles.dateCVVInputGroup, maginVertical8]
    }, {
      children: [isValidObject(cardDateInputProps) && _jsx(Input, Object.assign({
        value: date
      }, cardDateInputProps, getTestId(testID, 'Input'), {
        containerStyle: payCategoryCardWidgetStyles.dateInput,
        onChangeText: onDateHandler,
        hintText: dateHint,
        onFocus: () => {
          inputFieldOnPress(cardDateInputProps);
        },
        state: getInputState()
      })), isValidObject(cardCVVInputProps) && _jsx(Input, Object.assign({
        value: cvv
      }, getTestId(testID, 'Input'), {
        onChangeText: text => {
          setCvv(text);
        }
      }, cardCVVInputProps, {
        appendItems: Object.assign(Object.assign({}, appendItems), {
          onPress: onAppendItemPress
        }),
        onFocus: () => {
          inputFieldOnPress(cardCVVInputProps);
        },
        onHintActionPressHandler: hintActionOnPressFunc,
        secureTextEntry: isSecureTextEntry,
        containerStyle: payCategoryCardWidgetStyles.cvvInput
      }))]
    })), !!trustMarkerCtaTitle && showTrustMarker && _jsx(View, Object.assign({
      style: [maginVertical8]
    }, {
      children: _jsx(Checkbox, {
        checked: checked,
        label: trustMarkerTitle,
        actionCta: trustMarkerCtaTitle,
        onActionCtaPress: trustMarkerCtaonPress,
        onPress: () => {
          onCheckBoxPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({}, onCheckBoxPressMetaData), {
            trustMarkerTitle,
            checkboxStatus: checked ? 'unchecked' : 'checked'
          }));
          setChecked(!checked);
        }
      })
    })), isValidObject(buttonProps) && _jsx(ButtonWidget, Object.assign({}, buttonProps, getTestId(testID, 'Button'), {
      leftCta: Object.assign(Object.assign({}, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.leftCta), {
        controlState: controlState
      }),
      rightCta: Object.assign({}, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.rightCta),
      style: [maginVertical8],
      onUserAction: (data, extraData) => {
        _onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(data, Object.assign(Object.assign({}, extraData), {
          cardNumber,
          date,
          cvv,
          checked
        }));
      }
    }))]
  }));
};
PayCategoryCardWidgetComponent.genericRendererKey = 'AirPayCategoryCardWidget';